var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminProductList',{attrs:{"data":_vm.products,"product-name":"nodutrymningsbeslag","product-code":"nb"},on:{"on-deleted-item":_vm.fetchNb}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }